export default __webpack_public_path__ + "static/media/emptystar.11a1b54e.svg";